import { comfortAllowed } from "@/lib/consent";

const KEY = "devisto_device";

export const getDeviceId = () => {
  if (!comfortAllowed()) return "";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(KEY, id);
  }
  return id;
};

export const setDeviceId = (id) => { if (id && comfortAllowed()) localStorage.setItem(KEY, id); };
